
import {mapGetters} from 'vuex';
import articleQuery from '~/graphql/queries/article.gql';
import articlesQuery from '~/graphql/queries/articles.gql';

export default {
  auth: false,
  apollo: {
    article: {
      query: articleQuery,
      variables() {
        return {
          slug: this.$route?.params?.slug,
        };
      },
      update: data => data.articles.data?.[0] ?? {},
      result({data}) {
        const article = data.articles.data?.[0] ?? null;

        if (!article) {
          return this.$nuxt.error({statusCode: 404, message: 'Pagina niet gevonden'});
        }
      },
    },
    articles: {
      query: articlesQuery,
      variables() {
        return {
          notSlug: this.$route?.params?.slug,
        };
      },
    },
  },
  data: () => ({
    article: {},
    articles: [],
  }),
  computed: {
    ...mapGetters([
      'getFromSettings',
    ]),
    title() {
      return this.article?.advertorial ? `Advertorial: ${this.article?.title}` : this.article?.title;
    },
  },
};
